const headRowsManagementEquip = {
  equipmentModelName: 'Equipo',
  equipmentGroupName: 'Grupo',
  placeName: 'Lugar',
  referenceName: 'Punto de referencia',
  description: 'Descripción',
  company: 'Terceiras empresas',
  createdAt: 'Creado en',
};

export default headRowsManagementEquip;
